import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LocalStorageService } from '../core/services/common/localstorage-service';
import { DateService } from '../core/services/common/date-service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
})
export class App {
  private localStorageService = inject(LocalStorageService);
  private dateService = inject(DateService);

  constructor() {
    this.initializeTimezone();
  }

  private initializeTimezone(): void {
    const timezone = this.dateService.getBrowserTimezoneOffset();
    this.localStorageService.set('utc_offset', timezone.offset);
  }
}
